__turbopack_context__.v({
  "carousel__container": "WSrO2W_carousel__container",
  "carousel__filter": "WSrO2W_carousel__filter",
  "carousel__filters": "WSrO2W_carousel__filters",
  "carousel__item": "WSrO2W_carousel__item",
});
